function moveParagraph() {
    const entryWrapper = document.querySelector('.entry-wrapper');
    const tags = document.querySelector('.entry.default-description');
    if (entryWrapper && tags) {
        entryWrapper.insertAdjacentElement('afterbegin', tags);
        document.querySelector("body").classList.add("move-tag");
    }

}

export { moveParagraph };


// WEBPACK FOOTER //
// ./scriptPartials/moveParagraph.js